<template>
  <div>
    <canvas :id="id" style="width: 150px; height: 80px"> </canvas>
  </div>
</template>
    
<script>
import moment from "moment"
import Vue from 'vue'

export default {
  props:{
    id: String,
    data: {type:Array, default:() => []},
  },
  components: {

  },
  data(){
    return {
      width: 130,
      height: 70,
      paddingX: 10,
      paddingY: 5,
      ctx: undefined
    }
  },
  mounted() {
    this.initCancas()
  },
  methods: {
    initCancas() {
      let canvas = document.getElementById(this.id); 
      canvas.width = this.width + this.paddingX*2
      canvas.height = this.height + this.paddingY*2
      let ctx = canvas.getContext('2d');   
      this.ctx = ctx      
      this.drawPoints()        
      // ctx.fillStyle="#000";                             
      // ctx.fillRect(0,0,this.width,this.height);                        
    },
    drawPoints() {
      const self = this
      function calcY(v) {
        v=v>5?0:v<-5?10:5-v
        return v/10*self.height + self.paddingY
      }
      function calcX(index, len) {
        if(index===0) {
          return 0 + self.paddingX
        }
        else {
          return self.width / (len-1) * index + self.paddingX
        }
      }
      // 绘制辅助线
      const _y1 = calcY(1)
      this.ctx.beginPath();
      this.ctx.strokeStyle = '#cccccc'
      this.ctx.moveTo(self.paddingX, _y1);
      this.ctx.lineTo(self.width+self.paddingX, _y1);
      this.ctx.setLineDash([2, 2]);
      this.ctx.stroke();
      this.ctx.closePath();

      let _ls = 0;
      let _lx = 0;
      let _ly = 0;
      this.ctx.setLineDash([]);
      this.ctx.font="11px Arial";
      const data = [...this.data].sort((a, b)=>{return a.index - b.index})
      data.forEach((p, pi)=>{
        const _x = calcX(pi, this.data.length)
        const _y = calcY(p.score)
        this.ctx.beginPath();
        this.ctx.arc( _x, _y, 3.5, 0, 3.5*Math.PI );
        this.ctx.fillStyle = p.score >= 1?'#4caf50':'#aaaaaa'
        this.ctx.fill();
        const _s = `${p.score%1===0?p.score:p.score.toFixed(1)}`
        const txtWidth = this.ctx.measureText(_s).width
        this.ctx.fillStyle = p.score >= 1?'#4caf50':'#666666'
        this.ctx.fillText(_s, _x-(txtWidth/2), p.score<0?_y-8:_y+18);
        if(pi > 0) {
          this.ctx.strokeStyle = p.score>=1 && _ls>=1 ?'#4caf50' : '#aaaaaa'
          this.ctx.moveTo(_lx, _ly);
          this.ctx.lineTo(_x, _y);
          this.ctx.stroke();
        }
        this.ctx.closePath();
        _lx = _x;
        _ly = _y;
        _ls = p.score
        // this.ctx.stroke();
      })
    }
  }
}
</script>
<style lang="less">

</style>